module.exports = __webpack_public_path__ + "img/Company-icon.9ee3a03d.png";